module.exports = __webpack_public_path__ + "static/img/passion-07.34be558.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/passion-07.png
// module id = 132
// module chunks = 0